import React from 'react';
import { Text, View } from 'react-native';

export default class Text4 extends React.Component 
 {

    UpdateData()
   {
      var sNewS = this.props.ggg();

      if (this.state.myState != sNewS)
         this.setState({myState: sNewS});

      //this.setState({myState: this.props.ggg()});
   }
   
    constructor(props)
    {
    super(props);

    this.UpdateData1 = this.UpdateData.bind(this);
    }


    componentDidMount() 
    {
      //console.log("Text4 mount...");
      this.props.bbb(this.UpdateData1, true);
    }

    componentWillUnmount() 
    {
      //console.log("Text4 un-mount...");
      this.props.bbb(this.UpdateData1, false);
    }

   
   state = {
      myState: ""
   }

   render() 
     {
      return (
       <View style={this.props.getstyle()}>
       <Text style={this.props.style}> {this.state.myState} </Text>
       </View>
      );
   }
}